import { render, staticRenderFns } from "./CInformacionAviso.vue?vue&type=template&id=512b8125&"
import script from "./CInformacionAviso.vue?vue&type=script&lang=js&"
export * from "./CInformacionAviso.vue?vue&type=script&lang=js&"
import style0 from "./CInformacionAviso.vue?vue&type=style&index=0&id=512b8125&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports